import { IPrivatePageBase } from './private-page.interface';
import { PublicPageBase } from '../public-page/public-page.base';

export abstract class PrivatePageBase extends PublicPageBase implements IPrivatePageBase { 

}